
  import { Component, Vue } from 'vue-property-decorator';
  import VueCookies from 'vue-cookies';

  import { mapGetters } from 'vuex';

  import { IErrorModel } from '@/models/errors.model';

  Vue.use(VueCookies);

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'redirectUrl'
      ])
    }
  })
  export default class Information extends Vue {
    data() {
      return {
        "lastCheck": 0,
        "lastTwitchCheck": 0,
        errors: new Array<IErrorModel>(),
        isUpdatingEmailDisabled: false,
        isUpdatingUsernameDisabled: false,
        showPasswordSection: false,
        showEmailSection: false,
        showUsernameSection: false,
        showUpdateEmailButton: true,
        showUpdateUsernameButton: true,
      }
    }

    created() {
      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'CREATIVE-ASSEMBLY' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'FOCUS' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STILLFRONT'|| this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'UBISOFT-PLAYER-COUNCIL') {
        this.$data.isUpdatingEmailDisabled = true;
        this.$data.showEmailSection = this.$data.RCEnvironment.VUE_APP_ENVIRONMENT != 'UBISOFT-PLAYER-COUNCIL';
        this.$data.showUsernameSection = true;
        this.$data.showPasswordSection = false;
        this.$data.showUpdateEmailButton = false;
        this.$data.showUpdateUsernameButton = false;
        this.$data.isUpdatingUsernameDisabled = true;
      } else if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
        this.$data.showEmailSection = false;
        this.$data.showUsernameSection = true;
        this.$data.showPasswordSection = true;
      } else {
        this.$data.showEmailSection = true;
        this.$data.showUsernameSection = true;
        this.$data.showPasswordSection = true;
      }
    }

    goToUpdateEmail() {
      if (!["CREATIVE-ASSEMBLY"].includes(this.$data.RCEnvironment.VUE_APP_ENVIRONMENT)) {
        this.$router.push({ name: "UpdateEmail" });
      }
    }

    goToUpdateUsername() {
      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT != "CREATIVE-ASSEMBLY") {
        this.$router.push({ name: "UpdateUsername" });
      }
    }
  }
